import { checkIsPlatform, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getPriceDetailWidgetStyles = isLargeScreen => {
  var spacing = tokens.spacing;
  return StyleSheet.create({
    priceBreakupContainer: Object.assign(Object.assign({}, checkIsPlatform('web') && {
      marginLeft: -tokens.spacing.SPACING_4
    }), {
      paddingRight: isLargeScreen ? spacing.SPACING_24 : spacing.SPACING_16
    }),
    priceBreakupOldPrice: {
      marginTop: tokens.spacing.SPACING_4
    },
    textSpacer: {
      marginLeft: tokens.spacing.SPACING_4
    },
    gridRowStyle: {
      alignItems: 'center',
      justifyContent: 'center',
      alignSelf: 'flex-start'
    },
    gridColStyle: {
      paddingLeft: spacing.SPACING_4
    }
  });
};